// import React, { Component } from "react";
// import _ from "lodash";
// import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
// import Switch from "react-switch";
// import Multiselect from "react-widgets/lib/Multiselect";
// import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
// import { fire, auth } from "../../firebase/index";
// import { customLog } from "../../variables/Variables";
// import "../../assets/css/maincss.css";
// import "../../assets/css/header.css";
// import LocalizedStrings from "react-localization";
// //import localization
// //Localization codes
// let localizationStrings = new LocalizedStrings({
//   en: {
//     permissionTitle: "Permission",
//     adminEmailTitle: "Admin Email",
//     remarkTitle: "Remark",
//     approvalAllow: "Approved",
//     approvalDeny: "Denied",
//     approvalPending: "Pending",
//     approvalStatusTitle: "Current User Approval Status",
//     remarkTitle: "Current User Remark",
//     approvalChangeTitle: "Change User Approval to",
//     allow: "Allow",
//     deny: "Deny",
//     saveChanges: "Save Changes",
//     remarkInput: "Give an reason for not approving this lock"
//   },
//   ja: {
//     permissionTitle: "許可",
//     adminEmailTitle: "管理者メール",
//     remarkTitle: "理由",
//     approvalAllow: "承認を許可する",
//     approvalDeny: "承認を拒否する",
//     approvalPending: "承認待ちの",
//     approvalStatusTitle: "現在の承認ステータス",
//     remarkTitle: "現在の発言",
//     approvalChangeTitle: "承認をに変更",
//     allow: "許可する",
//     deny: "拒否",
//     saveChanges: "変更内容を保存",
//     remarkInput: "このロックを承認しない理由を説明してください"
//   }
// });

// class ApprovalBtn extends Component {
//   constructor(props) {
//     super(props);

//     const accessData = this.props.accessData;

//     this.state = {
//       currentApprovalStatus: false,
//       formattedApproveStatus: "",
//       changeApproveTo: true,
//       showPopup: false,
//       accessData: accessData,
//       inputRemark: "",
//       remarkDisable: false,
//       isRemarkExist: null,
//       isRemarkContent: "",
//       permissionList: [],
//       isSaveBtnDisable: false,
//       toggleSwitch: true
//     };

//     this.handlePopupClose = this.handlePopupClose.bind(this);
//     this.handlePopupOpen = this.handlePopupOpen.bind(this);
//     this.handleInputText = this.handleInputText.bind(this);
//     this.handleSaveButton = this.handleSaveButton.bind(this);
//     this.permissionFormat = this.permissionFormat.bind(this);
//     this.remarkFormat = this.remarkFormat.bind(this);
//     this.handleSwitchState = this.handleSwitchState.bind(this);
//   }

//   componentWillMount() {
//     fire
//       .database()
//       .ref("retractableSharingRegistry")
//       .child(this.state.accessData.senderUID)
//       .child(this.state.accessData.key)
//       .child("multiSharingAdmins")
//       .child(auth.currentUser.uid)
//       .once("value")
//       .then(async snapshot => {
//         if (snapshot.exists) {
//           const userMultiApprove = snapshot.val();
//           //! check of remark variable exist or not
//           if (
//             userMultiApprove.remark === undefined ||
//             userMultiApprove.remark === null
//           ) {
//             //! remark variable do not exist
//             await this.setState({
//               currentApprovalStatus: userMultiApprove.hasAllowed,
//               isRemarkContent: userMultiApprove.remark,
//               isRemarkExist: false
//             });
//           } else {
//             //! remark variable exist
//             await this.setState({
//               currentApprovalStatus: userMultiApprove.hasAllowed,
//               isRemarkContent: userMultiApprove.remark,
//               isRemarkExist: true
//             });
//           }
//         }
//       });

//     //! FOR LANGUAGE
//     if (auth.currentUser !== null) {
//       fire
//         .database()
//         .ref("userSettings")
//         .child(auth.currentUser.uid) // get uid from auth person object
//         .child("language")
//         .on("value", snapshot => {
//           this.setState({
//             currentLanguage: snapshot.val()
//           });
//         });
//     }
//   }

//   handlePopupOpen() {
//     this.setState({
//       showPopup: true
//     });

//     const permissionAdminList = this.state.accessData.permissionAdminList;

//     let permissionList = [];
//     for (const i in permissionAdminList) {
//       permissionList.push(permissionAdminList[i]);
//     }

//     this.setState({
//       permissionList: permissionList
//     });

//     if (this.state.permissionList.length <= 0) {
//       this.setState({
//         noDataText: "No data found"
//       });
//     }
//   }

//   handlePopupClose() {
//     this.setState({ showPopup: false });
//   }

//   handleInputText(remark) {
//     if (remark !== "") {
//       this.setState({
//         inputRemark: remark.target.value,
//         isSaveBtnDisable: false
//       });
//     } else {
//       this.setState({
//         isSaveBtnDisable: true
//       });
//     }
//   }

//   async handleSaveButton() {
//     let isRemark = this.state.inputRemark;

//     // if (this.state.changeApproveTo === true) {
//     //   isRemark = "";
//     // } else {
//     //   isRemark = this.state.inputRemark;
//     // }

//     const accessData = this.props.accessData;
//     await fire
//       .database()
//       .ref("retractableSharingRegistry")
//       .child(accessData.senderUID)
//       .child(accessData.key)
//       .child("multiSharingAdmins")
//       .child(auth.currentUser.uid)
//       .update({
//         hasAllowed: this.state.changeApproveTo,
//         remark: isRemark
//       })
//       .then(() => {
//         this.setState({
//           currentApprovalStatus: this.state.changeApproveTo,
//           isRemarkContent: isRemark,
//           isRemarkExist: true
//         });
//       })
//       .then(() => {
//         window.location.reload();
//       });
//   }

//   permissionFormat(permssion, row) {
//     if (row !== undefined) {
//       let remark = row.remark;

//       if (permssion === true) {
//         return localizationStrings.approvalAllow;
//       } else if (permssion === false) {
//         if (remark !== null && remark !== undefined && remark !== "") {
//           return localizationStrings.approvalDeny;
//         } else {
//           return localizationStrings.approvalPending;
//         }
//       }
//     }
//   }

//   remarkFormat(remark) {
//     if (remark !== null && remark !== undefined && remark !== "") {
//       return remark;
//     } else {
//       return "None";
//     }
//   }

//   handleSwitchState() {
//     if (this.state.toggleSwitch === false) {
//       //!Allow Approval
//       this.setState({
//         changeApproveTo: true,
//         isSaveBtnDisable: false
//         // remarkDisable: true
//       });
//     } else {
//       //!Deny Approval
//       this.setState({
//         changeApproveTo: false,
//         remarkDisable: false,
//         isSaveBtnDisable: true
//       });
//     }
//     this.setState({
//       toggleSwitch: !this.state.toggleSwitch
//     });
//   }

//   render() {
//     //! FOR LANGUAGE SETTING
//     if (this.state.currentLanguage === "en") {
//       localizationStrings.setLanguage("en");
//     } else if (this.state.currentLanguage === "ja") {
//       localizationStrings.setLanguage("ja");
//     }

//     const columnHover = (cell, row, enumObject, rowIndex) => {
//       return cell;
//     };

//     return (
//       <div>
//         <Modal
//           show={this.state.showPopup}
//           onHide={this.handlePopupClose}
//           dialogClassName="modal-70w"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>{localizationStrings.permissionTitle}</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <BootstrapTable
//               data={this.state.permissionList}
//               bordered={false}
//               options={{
//                 sizePerPage: 10,
//                 hideSizePerPage: true,
//                 noDataText: this.state.noDataText
//               }}
//             >
//               <TableHeaderColumn isKey={true} dataField="adminUid" hidden />
//               <TableHeaderColumn
//                 dataField="adminEmail"
//                 columnTitle={columnHover}
//               >
//                 {localizationStrings.adminEmailTitle}
//               </TableHeaderColumn>

//               <TableHeaderColumn
//                 dataField="hasAllowed"
//                 dataFormat={this.permissionFormat}
//                 width="200px"
//                 columnTitle={this.permissionFormat}
//               >
//                 {localizationStrings.permissionTitle}
//               </TableHeaderColumn>

//               <TableHeaderColumn
//                 dataField="remark"
//                 dataFormat={this.remarkFormat}
//                 columnTitle={this.remarkFormat}
//               >
//                 {localizationStrings.remarkTitle}
//               </TableHeaderColumn>
//             </BootstrapTable>
//             <br />
//             <table>
//               <tbody>
//                 <tr>
//                   <th>{localizationStrings.approvalStatusTitle}:</th>
//                   <th>
//                     {this.state.currentApprovalStatus === true
//                       ? localizationStrings.approvalAllow
//                       : this.state.isRemarkExist === true
//                       ? localizationStrings.approvalDeny
//                       : localizationStrings.approvalPending}
//                   </th>
//                 </tr>
//                 <tr>
//                   <th>{localizationStrings.remarkTitle}:</th>
//                   <th> {this.remarkFormat(this.state.isRemarkContent)}</th>
//                 </tr>
//               </tbody>
//             </table>
//             <hr />
//             <table>
//               <tbody>
//                 <tr>
//                   <th>
//                     {localizationStrings.approvalChangeTitle}:{" "}
//                     {this.state.changeApproveTo
//                       ? localizationStrings.approvalAllow
//                       : localizationStrings.approvalDeny}
//                   </th>

//                   <th>
//                     {" "}
//                     <Switch
//                       onChange={this.handleSwitchState}
//                       checked={this.state.toggleSwitch}
//                       id="normal-switch"
//                     />
//                   </th>
//                 </tr>
//               </tbody>
//             </table>
//             <FormControl
//               type="text"
//               value={this.state.inputRemark}
//               placeholder={localizationStrings.remarkInput}
//               onChange={this.handleInputText}
//               disabled={this.state.remarkDisable}
//             />
//             <Button
//               style={{
//                 backgroundColor: "orange",
//                 color: "black",
//                 border: "none"
//               }}
//               onClick={this.handleSaveButton}
//               disabled={
//                 (this.state.changeApproveTo === false &&
//                   this.state.inputRemark === "") ||
//                 this.state.isSaveBtnDisable
//               }
//             >
//               {localizationStrings.saveChanges}
//             </Button>
//             <p
//               style={{
//                 color: "red",
//                 display:
//                   (this.state.changeApproveTo === false &&
//                     this.state.inputRemark === "") ||
//                   this.state.isSaveBtnDisable
//                     ? "block"
//                     : "none"
//               }}
//             >
//               *You are required to give a reason for not approving this
//               permission!
//             </p>
//           </Modal.Body>
//         </Modal>

//         <button
//           onClick={this.handlePopupOpen}
//           className="approveBtn"
//           style={
//             this.state.currentApprovalStatus === true
//               ? { backgroundColor: "lightgreen" }
//               : this.state.isRemarkExist === true
//               ? { backgroundColor: "red" }
//               : { backgroundColor: "lightgrey" }
//           }
//         >
//           {this.state.currentApprovalStatus === true
//             ? localizationStrings.approvalAllow
//             : this.state.isRemarkExist === true
//             ? localizationStrings.approvalDeny
//             : localizationStrings.approvalPending}
//         </button>
//       </div>
//     );
//   }
// }

// export default ApprovalBtn;

import React, { Component } from "react";
import _ from "lodash";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import Switch from "react-switch";
import Multiselect from "react-widgets/lib/Multiselect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables";
import transferWithinAStation from "material-ui/svg-icons/maps/transfer-within-a-station";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    permissionTitle: "Permission",
    adminEmailTitle: "Admin Email",
    remarkTitle: "Remarks",
    approvalAllow: "Approved",
    approvalDeny: "Denied",
    approvalPending: "Pending",
    approvalStatusTitle: "My Approval Status",
    approvalRemarkTitle: "My Remark",
    approvalChangeTitle: "Change User Approval to",
    allow: "Allow",
    deny: "Deny",
    closePopup: "Close",
    saveChanges: "Save Changes",
    senderEmail: "Person in-charge",
    senderStatus: "Sender Approval Status",
    remarkInputApprove: "Remark(s)",
    remarkEmpty: "None",
    remarkInputDeny: "Provide a reason for not approving this lock",
    inputInvalid:
      "* You are required to give a reason for not approving this permission",
    permissionDisabled:
      "The person in-charge has blocked this lock access. All approval status for this lock will be ignored.",
    noDataTitle: "There is no data to display",
    loading: "Loading...",
    updateAlert: "Approval status updated successfully",
  },
  ja: {
    permissionTitle: "マルチ承認",
    adminEmailTitle: "管理者メール",
    remarkTitle: "詳細",
    approvalAllow: "承認を許可する",
    approvalDeny: "無効",
    approvalPending: "承認待ちの",
    approvalStatusTitle: "現在の承認ステータス",
    approvalRemarkTitle: "現在の発言",
    approvalChangeTitle: "承認をに変更",
    allow: "許可する",
    deny: "拒否",
    closePopup: "画面を閉じる",
    saveChanges: "変更内容を保存",
    senderEmail: "承認担当",
    senderStatus: "承認状況",
    remarkInputApprove: "の発言",
    remarkEmpty: "なし",
    remarkInputDeny: "このロックを承認しない理由を説明してください",
    inputInvalid: "* 承認不可の理由を入力して下さい。",
    permissionDisabled:
      "無効設定：メンバーへのアクセス設定が全て無効になります。",
    noDataTitle: "表示するデータがありません。",
    loading: "読み込み中...",
    updateAlert: "承認ステータスが正常に更新されました",
  },
  es: {
    permissionTitle: "Permiso",
    adminEmailTitle: "Correo Electrónico del Administrador",
    remarkTitle: "Comentarios",
    approvalAllow: "Aprobado",
    approvalDeny: "Denegado",
    approvalPending: "Pendiente",
    approvalStatusTitle: "Mi Estado de Aprobación",
    approvalRemarkTitle: "Mi Comentario",
    approvalChangeTitle: "Cambiar la Aprobación del Usuario a",
    allow: "Permitir",
    deny: "Denegar",
    closePopup: "Cerrar",
    saveChanges: "Guardar Cambios",
    senderEmail: "Persona a cargo",
    senderStatus: "Estado de Aprobación del Remitente",
    remarkInputApprove: "Comentario(s)",
    remarkEmpty: "Ninguno",
    remarkInputDeny: "Proporcione una razón para no aprobar esta candado",
    inputInvalid: "* Se requiere dar una razón para no aprobar este permiso",
    permissionDisabled:
      "La persona a cargo ha bloqueado el acceso a esta candado. Todos los estados de aprobación para esta candado serán ignorados.",
    noDataTitle: "No hay datos para mostrar",
    loading: "Cargando...",
    updateAlert: "Estado de aprobación actualizado exitosamente",
  },
});

class ApprovalBtn extends Component {
  constructor(props) {
    super(props);

    const accessData = this.props.accessData;

    this.state = {
      accessData: accessData,
      showPopup: false,
      permissionList: [],
      isApproved: null,
      currentRemark: undefined,
      toggleSwitch: true,
      inputRemark: "",
      loading: true,
      _notificationSystem: null,
    };

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handleInputText = this.handleInputText.bind(this);
    this.handleSaveButton = this.handleSaveButton.bind(this);
    this.permissionFormat = this.permissionFormat.bind(this);
    this.remarkFormat = this.remarkFormat.bind(this);
    this.handleSwitchState = this.handleSwitchState.bind(this);
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    const accessData = this.state.accessData;

    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(accessData.senderUID)
      .child(accessData.key)
      .child("multiSharingAdmins")
      .once("value")
      .then(async (snapshot) => {
        var tempArray = [];
        if (snapshot.exists()) {
          snapshot.forEach((admin) => {
            const adminData = admin.val();

            if (adminData.adminUid === auth.currentUser.uid) {
              if (adminData.remark !== undefined) {
                this.setState({
                  isApproved: adminData.hasAllowed,
                  currentRemark: adminData.remark,
                });
              }
            }

            tempArray.push(adminData);

            this.setState({
              permissionList: tempArray,
            });
          });
          this.setState({ loading: false });
        }
      });

    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  handlePopupOpen() {
    let boolean = true;

    if (this.state.isApproved === false) {
      boolean = false;
    }

    this.setState({
      showPopup: true,
      toggleSwitch: boolean,
      inputRemark: "",
    });
  }

  handlePopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  handleInputText(remark) {
    this.setState({
      inputRemark: remark.target.value,
    });
  }

  async handleSaveButton() {
    let status = this.state.toggleSwitch;
    let remark = this.state.inputRemark;

    const accessData = this.state.accessData;

    if (accessData.allowAccess) {
      await fire
        .database()
        .ref("retractableSharingRegistry")
        .child(accessData.senderUID)
        .child(accessData.key)
        .child("multiSharingAdmins")
        .child(auth.currentUser.uid)
        .update({
          hasAllowed: status,
          remark: remark,
        })
        .then(() => {
          fire
            .database()
            .ref("retractableSharingRegistry")
            .child(accessData.senderUID)
            .child(accessData.key)
            .child("multiSharingAdmins")
            .once("value")
            .then(async (snapshot) => {
              var tempArray = [];
              if (snapshot.exists()) {
                snapshot.forEach((admin) => {
                  const adminData = admin.val();

                  tempArray.push(adminData);

                  this.setState({
                    permissionList: tempArray,
                    isApproved: status,
                    currentRemark: remark,
                    showPopup: false,
                  });
                });
              }
            });
        });
    } else {
      this.setState({ showPopup: false });
    }

    this.showNotification(`${localizationStrings.updateAlert}`, "success", 5);
  }

  permissionFormat(permission, row) {
    if (row.remark !== undefined) {
      if (permission === true) {
        return (
          <span
            style={
              this.state.accessData.allowAccess
                ? { color: "green" }
                : { color: "grey" }
            }
          >
            {localizationStrings.approvalAllow}
          </span>
        );
      } else if (permission === false) {
        return (
          <span
            style={
              this.state.accessData.allowAccess
                ? { color: "red" }
                : { color: "grey" }
            }
          >
            {localizationStrings.approvalDeny}
          </span>
        );
      }
    } else {
      return (
        <span
          style={this.state.accessData.allowAccess ? {} : { color: "grey" }}
        >
          {localizationStrings.approvalPending}
        </span>
      );
    }
  }

  remarkFormat(remark) {
    if (remark !== null && remark !== undefined && remark !== "") {
      return remark;
    } else {
      return localizationStrings.remarkEmpty;
    }
  }

  handleSwitchState() {
    this.setState({
      toggleSwitch: !this.state.toggleSwitch,
      inputRemark: "",
    });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }

    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        {this.state.loading && (
          <button
            disabled={true}
            className="approveBtn"
            style={{ backgroundColor: "lightgrey", color: "black" }}
          >
            {localizationStrings.loading}
          </button>
        )}
        {!this.state.loading && (
          <button
            onClick={this.handlePopupOpen}
            className="approveBtn"
            style={
              this.state.isApproved === true
                ? { backgroundColor: "green", color: "white" }
                : this.state.isApproved === false
                ? { backgroundColor: "red", color: "white" }
                : { backgroundColor: "lightgrey", color: "black" }
            }
          >
            {this.state.isApproved === true
              ? localizationStrings.approvalAllow
              : this.state.isApproved === false
              ? localizationStrings.approvalDeny
              : localizationStrings.approvalPending}
          </button>
        )}

        {/* //! Popup for Approval */}
        <Modal
          show={this.state.showPopup}
          onHide={this.handlePopupClose}
          dialogClassName="modal-70w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.permissionTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br />
            <table style={{ width: "100%" }}>
              <tbody style={{ width: "100%" }}>
                <tr>
                  <th style={{ width: "20%", minWidth: "260px" }}>
                    {localizationStrings.senderEmail} :
                  </th>
                  <th style={{ width: "80%" }}>
                    {this.state.accessData.shareFrom}
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "20%", minWidth: "260px" }}>
                    {localizationStrings.senderStatus} :
                  </th>
                  <th style={{ width: "80%" }}>
                    {this.state.accessData.allowAccess ? (
                      <span>{localizationStrings.approvalAllow}</span>
                    ) : (
                      <span style={{ color: "red" }}>
                        {localizationStrings.approvalDeny}
                      </span>
                    )}
                  </th>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <BootstrapTable
              data={this.state.permissionList}
              bordered={true}
              options={{
                sizePerPage: 10,
                hideSizePerPage: true,
                noDataText: localizationStrings.noDataTitle,
              }}
            >
              <TableHeaderColumn isKey={true} dataField="adminUid" hidden />
              <TableHeaderColumn
                dataField="adminEmail"
                columnTitle={columnHover}
              >
                {localizationStrings.adminEmailTitle}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="hasAllowed"
                dataFormat={this.permissionFormat}
                width="200px"
                columnTitle={this.permissionFormat}
              >
                {localizationStrings.permissionTitle}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="remark"
                dataFormat={this.remarkFormat}
                columnTitle={this.remarkFormat}
              >
                {localizationStrings.remarkTitle}
              </TableHeaderColumn>
            </BootstrapTable>
            <br />
            <br />
            <table style={{ width: "100%" }}>
              <tbody style={{ width: "100%" }}>
                <tr>
                  <th style={{ width: "20%", minWidth: "260px" }}>
                    {localizationStrings.approvalStatusTitle} :
                  </th>
                  <th style={{ width: "80%" }}>
                    {this.state.isApproved === true ? (
                      <span
                        style={
                          this.state.accessData.allowAccess
                            ? { color: "green" }
                            : { color: "grey" }
                        }
                      >
                        {localizationStrings.approvalAllow}
                      </span>
                    ) : this.state.isApproved === false ? (
                      <span
                        style={
                          this.state.accessData.allowAccess
                            ? { color: "red" }
                            : { color: "grey" }
                        }
                      >
                        {localizationStrings.approvalDeny}
                      </span>
                    ) : (
                      <span>{localizationStrings.approvalPending}</span>
                    )}
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "20%", minWidth: "260px" }}>
                    {localizationStrings.approvalRemarkTitle} :
                  </th>
                  <th
                    style={
                      this.state.accessData.allowAccess
                        ? { width: "80%" }
                        : { width: "80%", color: "grey" }
                    }
                  >
                    {" "}
                    {this.remarkFormat(this.state.currentRemark)}
                  </th>
                </tr>
              </tbody>
            </table>
            <br />
            <hr />
            <table style={{ width: "100%" }}>
              <tbody style={{ width: "100%" }}>
                <tr>
                  <th style={{ width: "20%", minWidth: "260px" }}>
                    {localizationStrings.approvalChangeTitle} :{" "}
                    {this.state.toggleSwitch ? (
                      <span
                        style={
                          this.state.accessData.allowAccess
                            ? { color: "green" }
                            : { color: "grey" }
                        }
                      >
                        {localizationStrings.approvalAllow}
                      </span>
                    ) : (
                      <span
                        style={
                          this.state.accessData.allowAccess
                            ? { color: "red" }
                            : { color: "grey" }
                        }
                      >
                        {localizationStrings.approvalDeny}
                      </span>
                    )}
                  </th>

                  <th
                    style={{
                      display: "flex",
                      width: "80%",
                      alignItems: "center",
                    }}
                  >
                    <Switch
                      onChange={this.handleSwitchState}
                      checked={this.state.toggleSwitch}
                      id="normal-switch"
                      disabled={!this.state.accessData.allowAccess}
                    />
                    <div style={{ width: "10px" }} />
                    <span style={{ color: "red" }}>
                      {this.state.accessData.allowAccess
                        ? ""
                        : localizationStrings.permissionDisabled}
                    </span>
                  </th>
                </tr>
              </tbody>
            </table>
            <FormControl
              type="text"
              value={this.state.inputRemark}
              placeholder={
                this.state.toggleSwitch === false
                  ? localizationStrings.remarkInputDeny
                  : localizationStrings.remarkInputApprove
              }
              disabled={!this.state.accessData.allowAccess}
              onChange={this.handleInputText}
              style={{ marginTop: "10px", marginBottom: "10px" }}
            />
            <p
              style={{
                color: "red",
                display: this.state.accessData.allowAccess
                  ? this.state.toggleSwitch === false &&
                    this.state.inputRemark === ""
                    ? "block"
                    : "none"
                  : "none",
              }}
            >
              {localizationStrings.inputInvalid}
            </p>
            <Button
              style={{
                backgroundColor: "orange",
                color: "black",
                border: "none",
              }}
              onClick={this.handleSaveButton}
              disabled={
                this.state.accessData.allowAccess
                  ? this.state.toggleSwitch === false &&
                    this.state.inputRemark === ""
                  : false
              }
            >
              {this.state.accessData.allowAccess
                ? localizationStrings.saveChanges
                : localizationStrings.closePopup}
            </Button>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ApprovalBtn;
